import { makeStyles } from 'tss-react/mui';

import { MOBILE_BREAK_POINT } from 'app/constants';

export default makeStyles({ name: 'Contacts' })((theme) => ({
    container: {
        maxWidth: 856,
        margin: 'auto'
    },
    title: {
        marginTop: 40,
        marginBottom: 12,
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            marginTop: 40,
            marginBottom: 24
        }
    },
    subtitle: {
        margin: '0 auto',
        maxWidth: 640,
        color: '#fff',
        textAlign: 'center',
        fontSize: 18,
        fontWeight: 500,
        lineHeight: '27px',
        letterSpacing: '-0.54px'
    },
    sections: {
        marginTop: 80,
        marginBottom: 120,
        display: 'grid',
        gridTemplateAreas: `
            "demo demo"
            "sales support"
       `,
        gridTemplateColumns: '1fr 1fr',
        gridTemplateRows: 'auto',
        gap: 24,
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            display: 'flex',
            flexDirection: 'column',
            gap: 20,
            marginTop: 40,
            marginBottom: 96
        }
    },
    demo: {
        gridArea: 'demo'
    },
    sales: {
        gridArea: 'sales'
    },
    support: {
        gridArea: 'support'
    }
}));
